module.exports = __webpack_public_path__ + "img/cut-05-sp.774eea2a.jpg";